import Kebab from './kebab';
import Slide from './slide';
import Switch from './switch';

const Stepper = {
  Kebab, Slide, Switch,
};

export default Stepper;
